import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Airfare } from '../../../../../interfaces/src/lib/types/index';
import { loadFromSessionStorage } from '../../genericUtils/genericUtils';

export interface IAirport {
  code: string;
  name: string;
}

export interface IFlightData {
  airfares: Airfare[];
  selectedAirfare: Airfare | null;
  airports: IAirport[];
  businessClassAirfare: Airfare | null;
  selectedAirfares: Airfare[];
  isFlightUpgraded: boolean;
}

// Set the initial state for the flight data
const initialState: IFlightData = {
  airfares: [],
  selectedAirfare: null,
  selectedAirfares: [],
  airports: [],
  businessClassAirfare: null,
  isFlightUpgraded: false,
};

const flightDataSlice = createSlice({
  name: 'flightData',
  initialState: loadFromSessionStorage('flightData', initialState),
  reducers: {
    setAirfares: (state, action: PayloadAction<Airfare[]>) => {
      const airfareMap = new Map(
        state.airfares.map((a: Airfare) => [a.outbound.segments[0].origin.airport.code, a])
      );
      action.payload.forEach((a) => airfareMap.set(a.outbound.segments[0].origin.airport.code, a));
      state.airfares = Array.from(airfareMap.values());
    },
    setSelectedAirfare: (state, action: PayloadAction<Airfare | undefined>) => {
      state.selectedAirfare = action.payload;
    },
    setSelectedAirfares: (state, action: PayloadAction<Airfare[]>) => {
      state.selectedAirfares = action.payload;
    },
    setBusinessClassAirfare: (state, action: PayloadAction<Airfare | null>) => {
      state.businessClassAirfare = action.payload;
    },
    setAirports: (state, action: PayloadAction<IAirport[]>) => {
      state.airports = action.payload;
    },
    setIsFlightUpgraded: (state, action: PayloadAction<boolean>) => {
      state.isFlightUpgraded = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase('resetFromPriceType', () => {
        return initialState;
      })
      .addCase('resetFromOccupancy', () => {
        return initialState;
      })
      .addCase('resetFromCabinType', () => {
        return initialState;
      })
      .addCase('resetFromCabinCategories', () => {
        return initialState;
      }),
});

export const {
  setSelectedAirfare,
  setAirfares,
  setAirports,
  setBusinessClassAirfare,
  setIsFlightUpgraded,
  setSelectedAirfares,
} = flightDataSlice.actions;
export default flightDataSlice.reducer;
